import React, { useEffect, useState, useRef, useMemo } from "react";
import { AxiosInstance } from "../../../../../axios";
import Loader from "../../../Loader";
import styles from "../../Announcements/Announcement.module.css";
import moment from "moment";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import CustomDownloadButton from "../../../../ReusuableComponent/CustomDownloadButton/CustomDownloadButton";
import { Box, Chip, IconButton, Paper, Typography, Modal } from "@mui/material";
import { styled } from "@mui/material/styles";
import Pagination from "../../../../ReusuableComponent/Pagination/Pagination";
import CloseIcon from "@mui/icons-material/Close";
import DatePickerSample from "../../../DatePicker";
import InterviewPerformance from "./InterviewPerformanceList";

function FeedbackList() {
  const userJSON = sessionStorage.getItem("userDetails");
  const userId = userJSON ? JSON.parse(userJSON)?.user_id : null;
  const [isLoading, setIsLoading] = useState(false);
  const [batchList, setBatchList] = useState([]);
  const [combineTest, setCombineTest] = useState([]);
  const [activeTab, setActiveTab] = useState(0); // 0 = Interview Feedback
  const isMounted = useRef(true);
  const [appOns, setAppOns] = useState([]);
  const fDatePickerRef = useRef(null);
  const tDatePickerRef = useRef(null);
  const [appDatas, setAppDatas] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });
  const [appOn, setAppOn] = useState([]);
  const [appData, setAppData] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });
  const [sortKey, setSortKey] = useState("sno");
  const [interviewMode, setInterviewMode] = useState([]);
  const [interview_mode, setInterview_mode] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState([]);
  const [selectedStatus, setselectedStatus] = useState([]);
  const navigate = useNavigate();
  const [updateListData, setUpdateListData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10); // You can adjust this number as needed
  const [searchTerm, setSearchTerm] = useState("");
  const [categoryId, setCategoryId] = useState([]); // Category list for filter checkboxes
  const [showModal, setShowModal] = useState(false);
  const [selectedFeedback, setSelectedFeedback] = useState(null);
  const [reportData, setReportData] = useState([]);
  const txtBSearch = useRef(null);
  const filterRef = useRef(null);
  const [isOpen, setIsOpen] = useState({
    interview_mode: false,
    category: false,
    startDates: false,
    status: false,
  });
  const filterBoxRef = useRef(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [updateChipData, setUpdateChipData] = useState([]);

  const location = useLocation();
  const {
    filCateCode,
    filCateStatus,
    filCateSearch,
    filSearch,
    filInterviewMode,
    filCategory,
    filDate,
    filDateOn,
    filStatus,
    FILActiveTab,
    filBatchId,
  } = location.state || {};

  const [feedbackList, setFeedbackList] = useState([]);

  const [category_on, setCategory_on] = useState([]);
  const [intCategory_on, setIntCategory_on] = useState([]);

  const [reward_status, setReward_status] = useState([]);
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentData = feedbackList?.slice(start, end);

  const filterCategoryRef = useRef(null);
  const filterCreatedDateRef = useRef(null);
  const filterStatusRef = useRef(null);
  // ===== Modal states =====
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [selectedBatchId, setSelectedBatchId] = useState("");
  const [feedbackComment, setFeedbackComment] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [formErrors, setFormErrors] = useState({
    batch: "",
    comment: "",
  });

  // Open modal
  const openFeedbackModal = () => {
    setSelectedBatchId("");
    setFeedbackComment("");
    setShowFeedbackModal(true);
  };

  // Close modal
  const closeFeedbackModal = () => {
    setShowFeedbackModal(false);
  };
  const openAddFeedbackModal = () => {
    setSelectedBatchId("");
    setFeedbackComment("");
    setShowAddModal(true);
  };

  const closeAddFeedbackModal = () => {
    setShowAddModal(false);
  };

  // Submit feedback
  const handleSubmitFeedback = async () => {
    let errors = {
      batch: "",
      comment: "",
    };

    if (!selectedBatchId) {
      errors.batch = "Please select a batch";
    }

    if (!feedbackComment.trim()) {
      errors.comment = "Please enter feedback comments";
    }

    // if any error exists, stop submit
    if (errors.batch || errors.comment) {
      setFormErrors(errors);
      return;
    }

    setFormErrors({ batch: "", comment: "" });
    setSubmitLoading(true);

    try {
      const res = await AxiosInstance.post(
        "api/mockinterview/interview/create_feedback",
        {
          user_id: userId,
          batch_id: Number(selectedBatchId),
          comment: feedbackComment,
        }
      );

      if (res?.data?.status === true) {
        closeAddFeedbackModal();
        setSelectedBatchId("");
        setFeedbackComment("");
        setActiveTab(0);
        loadListdata();
      } else {
        setFormErrors({
          batch: "",
          comment: res?.data?.message || "Failed to submit feedback",
        });
      }
    } catch (err) {
      console.error("Create feedback error", err);
      setFormErrors({
        batch: "",
        comment: "Something went wrong. Please try again.",
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  const fetchViewFeedback = async (id) => {
    try {
      const res = await AxiosInstance.post(
        "api/mockinterview/interview/view_feedback",
        { id }
      );

      if (
        res?.data?.status === true &&
        Array.isArray(res.data.data) &&
        res.data.data.length > 0
      ) {
        //  TAKE FIRST OBJECT
        setSelectedFeedback(res.data.data[0]);
      } else {
        setSelectedFeedback(null);
      }

      setShowModal(true);
    } catch (error) {
      console.error("View feedback error", error);
      setSelectedFeedback(null);
      setShowModal(true);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        filterCategoryRef.current &&
        !filterCategoryRef.current.contains(event.target)
      ) {
        setIsOpen((prev) => ({ ...prev, category: false }));
      }

      if (
        filterStatusRef.current &&
        !filterStatusRef.current.contains(event.target)
      ) {
        setIsOpen((prev) => ({ ...prev, reward_status: false }));
      }

      if (
        filterCreatedDateRef.current &&
        !filterCreatedDateRef.current.contains(event.target)
      ) {
        setIsOpen((prev) => ({ ...prev, startDates: false }));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const [isFiltersInitialized, setIsFiltersInitialized] = useState(false);

  useEffect(() => {
    if (filSearch && filSearch.length > 0) {
      searchTerm(filSearch);
      filterSearch = filSearch;
    }
    if (filDate && filDate.length > 0) {
      setAppOns(filDate);
      filterApplyeds = filDate;
    }
    if (filDateOn && filDateOn.length > 0) {
      setAppOn(filDateOn);
      filterApplyed = filDateOn;
    }
    if (filCategory && filCategory.length > 0) {
      setIntCategory_on(filCategory);
      filterIntCategory = filCategory;
    }

    if (filInterviewMode && filInterviewMode.length > 0) {
      setInterview_mode(filInterviewMode);
      filterInterviewMode = filInterviewMode;
    }
    if (filStatus && filStatus.length > 0) {
      setselectedStatus(filStatus);
      filterStatus = filStatus;
    }
    setActiveTab(FILActiveTab || 0);
    setBatchId(filBatchId);
    setIsFiltersInitialized(true);
    loadChipdatas();
  }, []);

  useEffect(() => {
    if (isFiltersInitialized && filCategory && filCategory.length > 0) {
      loadListdata();
    } else if (
      isFiltersInitialized &&
      filInterviewMode &&
      filInterviewMode.length > 0
    ) {
      loadListdata();
    } else if (isFiltersInitialized && filStatus && filStatus.length > 0) {
      loadListdata();
    } else if (isFiltersInitialized && filDate && filDate.length > 0) {
      loadListdata();
    } else if (isFiltersInitialized && filDateOn && filDateOn.length > 0) {
      loadListdata();
    } else if (isFiltersInitialized && filSearch && filSearch.length > 0) {
      loadListdata();
    }
  }, [
    filSearch,
    filDate,
    filDateOn,
    filCategory,
    filInterviewMode,
    filStatus,
    isFiltersInitialized,
    updateChipData,
  ]);
  useEffect(() => {
    if (isFiltersInitialized) {
      loadListdata();
      loadListdatas();
    }
  }, [isFiltersInitialized, updateChipData]);
  // useEffect(() => {
  //   const temChip = updateChipData?.filter((ui) => ui.type === "category_on");
  //   const temArr = [];
  //   categoryId.map((item) => {
  //     let dataChip = { ...item, checked: false, type: "category_on" };
  //     temChip.map((itemChip) => {
  //       if (item.name === itemChip.name) {
  //         dataChip = { ...item, checked: true, type: "category_on" };
  //       }
  //     });
  //     temArr.push(dataChip);
  //   });
  //   setCategoryId(temArr);
  //   loadListdata(temChip);
  // }, [updateChipData]);

  // Handles Search Input and Updates Filter Chips
  const handleSearch = (event) => {
    if (event.key === "Enter") {
      let val = event.target.value;
      setSearchTerm(val);
      if (val.length > 0) {
        setUpdateChipData((prev) => [
          ...prev,
          { name: String(val), type: "search" },
        ]);
      } else {
        setSearchTerm("");
      }
    }
  };
  const [course_on, setCourse_on] = useState([]);
  const handleCheckboxChange = (event, typename) => {
    const { value, checked, name } = event.target;
    if (typename === "reward_status") {
      if (checked) {
        setReward_status([
          ...reward_status,
          { id: value, name: name, type: "reward_status" },
        ]);
      } else {
        setReward_status(reward_status.filter((item) => item.id !== value));
      }
    } else if (typename === "interview_mode") {
      if (checked) {
        setInterview_mode([{ id: value, name: name, type: "interview_mode" }]);
      } else {
        setInterview_mode(interview_mode.filter((item) => item.id !== value));
      }
    } else if (typename === "category") {
      if (checked) {
        setCategory_on([
          ...category_on,
          { id: value, name: name, type: "category" },
        ]);
      } else {
        setCategory_on(category_on.filter((item) => item.id !== value));
      }
    } else if (typename === "intCategory") {
      if (checked) {
        setIntCategory_on([
          ...intCategory_on,
          { id: value, name: name, type: "intCategory" },
        ]);
      } else {
        setIntCategory_on(intCategory_on.filter((item) => item.id !== value));
      }
    } else if (typename === "course") {
      if (checked) {
        setCourse_on([...course_on, { id: value, name: name, type: "course" }]);
      } else {
        setCourse_on(course_on.filter((item) => item.id !== value));
      }
    }
  };
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "90%", sm: "500px", md: "600px" },
    bgcolor: "background.paper",
    borderRadius: "8px",
    boxShadow: 24,
    p: 0,
  };
  // ------chipdata listitem------
  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));
  let filterCategory = [];
  let filterIntCategory = [];

  let filterApplyeds = [];
  let filterApplyed = [];
  let filterSearch = [];
  let filterStatus = [];
  let filterInterviewMode = [];
  function updateStateData() {
    filterCategory = [...category_on];
    filterIntCategory = [...intCategory_on];
    filterRewardStatus = [...reward_status];
    filterStatus = selectedStatus;
    filterInterviewMode = interview_mode;
    if (searchTerm.length > 0) {
      filterSearch = [{ name: searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }

  const handleApplyFilter = (name) => {
    updateStateData();
    if (name === "created_dt") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        startDates: false,
      });
    } else if (name === "category") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        category: false,
      });
    } else if (name === "intCategory") {
      loadChipdatas();
      setIsOpen({
        ...isOpen,
        intCategory: false,
      });
    } else if (name === "startDate") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        appliedOn: false,
      });
    } else if (name === "interview_mode") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        interview_mode: false,
      });
    } else if (name === "status") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        status: false,
      });
    }
  };
  const handleDelete = (chipToDelete, index) => () => {
    if (chipToDelete.type === "created_dt") {
      //  Clear DatePicker inputs
      setAppDatas({
        FDate: "",
        TDate: "",
        Days: "",
      });

      //  Clear applied date chips
      setAppOns([]);
      filterApplyeds = [];

      //  Remove chip from UI
      setUpdateChipData((prev) => prev.filter((e) => e.type !== "created_dt"));

      // Reload data without date filter
      loadListdata();

      return;
    }
    // --- EXISTING LOGIC (UNCHANGED) ---
    if (chipToDelete.type === "category") {
      setCategory_on(category_on.filter((item) => item.id !== chipToDelete.id));
      setUpdateChipData((prev) =>
        prev.filter((e) => !(e.type === "category" && e.id === chipToDelete.id))
      );
    } else if (chipToDelete.type === "intCategory") {
      setIntCategory_on(
        intCategory_on.filter((item) => item.id !== chipToDelete.id)
      );
      setUpdateChipData((prev) =>
        prev.filter(
          (e) => !(e.type === "intCategory" && e.id === chipToDelete.id)
        )
      );
    } else if (chipToDelete.type === "interview_mode") {
      setInterview_mode(
        interview_mode.filter((item) => item.id !== chipToDelete.id)
      );
      setUpdateChipData((prev) =>
        prev.filter(
          (e) => !(e.type === "interview_mode" && e.id === chipToDelete.id)
        )
      );
    } else if (chipToDelete.type === "search") {
      setSearchTerm("");
      filterSearch = [];
      setUpdateChipData((prev) => prev.filter((e) => e.type !== "search"));
    } else if (chipToDelete.type === "status") {
      setselectedStatus(
        selectedStatus.filter((item) => item.id !== chipToDelete.id)
      );
      setUpdateChipData((prev) =>
        prev.filter((e) => !(e.type === "status" && e.id === chipToDelete.id))
      );
    }
  };

  useEffect(() => {
    filterStatus = selectedStatus;
  }, [selectedStatus]);
  useEffect(() => {
    filterCategory = category_on;
  }, [category_on]);
  useEffect(() => {
    filterIntCategory = intCategory_on;
  }, [intCategory_on]);
  useEffect(() => {
    filterApplyeds = appOns;
  }, [appDatas]);
  useEffect(() => {
    filterApplyed = appOn;
  }, [appData]);
  // categoryList portion inside the category popup //
  useEffect(() => {
    AxiosInstance.get("api/course/category_list")
      .then((res) => {
        if (res.status === 200 && Array.isArray(res.data.data)) {
          // setIsLoading(false);
          const tempCate = [];
          res.data.data.map((item) => {
            item.checked = false;
            tempCate.push(item);
          });
          setCategoryId(tempCate);
        } else if (res.data.status === false) {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setFeedbackList([]);
        setIsLoading(false);
        return error;
      });
  }, []);

  let filterRewardStatus = [];

  function loadChipdata() {
    let tempArr = [];
    filterCategory.map((obj) => {
      tempArr.push(obj);
    });
    filterIntCategory.map((obj) => {
      tempArr.push(obj);
    });
    filterApplyeds.map((obj) => {
      tempArr.push(obj);
    });
    filterApplyed.map((obj) => {
      tempArr.push(obj);
    });
    filterStatus.map((obj) => {
      tempArr.push(obj);
    });
    filterInterviewMode.map((obj) => {
      tempArr.push(obj);
    });
    if (searchTerm.length > 0) {
      tempArr.push({ name: searchTerm, type: "search" });
    }
    setUpdateChipData(tempArr);
  }

  function loadChipdatas() {
    let tempArr = [];
    filterIntCategory.map((obj) => {
      tempArr.push(obj);
    });
    filterApplyeds.map((obj) => {
      tempArr.push(obj);
    });
    filterStatus.map((obj) => {
      tempArr.push(obj);
    });
    filterInterviewMode.map((obj) => {
      tempArr.push(obj);
    });
    if (searchTerm.length > 0) {
      tempArr.push({ name: searchTerm, type: "search" });
    }
    setUpdateChipData(tempArr);
  }

  // filter clear button
  const handleClearOn = (name) => {
    const updatedChips = updateChipData.filter((item) => item.type !== name);
    setUpdateChipData(updatedChips);
    setIsOpen({
      rating: false,
      status: false,
      startDates: false,
      intCategory: false,
    });

    if (name === "intCategory") {
      updateStateData();
      setCategory_on([]);
      setIntCategory_on([]);
      filterCategory = [];
    } else if (name === "interview_mode") {
      updateStateData();
      setInterview_mode([]);
      filterInterviewMode = [];
    } else if (name === "status") {
      const temArr = [];
      selectedStatus.map((item) => {
        temArr.push({ ...item, checked: false });
      });
      setselectedStatus(temArr);
    } else if (name === "startDate") {
      updateStateData();
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      filterApplyed = [];
      setIsOpen({
        ...isOpen,
        appliedOn: false,
      });
    }
  };
  const handleClear = (name) => {
    setIsOpen({
      interview_mode: false,
      category: false,
      startDates: false,
      status: false,
    });
    if (name === "category") {
      const temArr = [];
      categoryId.map((item) => {
        temArr.push({ ...item, checked: false });
      });
      setCategoryId(temArr);
    } else if (name === "status  ") {
      const temArr = [];
      selectedStatus.map((item) => {
        temArr.push({ ...item, checked: false });
      });
      setselectedStatus(temArr);
    } else if (name === "appliedOns") {
      updateStateData();
      // clear date fields
      setAppDatas({
        FDate: "",
        TDate: "",
        Days: "",
      });
      // clear applied date chips
      setAppOns([]);
      filterApplyeds = [];
      // remove date chips from main chip list
      setUpdateChipData((prev) =>
        prev.filter((e) => e.type !== "created_date")
      );

      setIsOpen({
        ...isOpen,
        startDates: false,
      });

      // reload list without date filter
      loadListdata();
    }
  };
  useEffect(() => {
    if (location.state) {
      navigate(location.pathname, {
        replace: true,
        state: {},
      });
    }
  }, []);

  const handleFilter = (e, boxName) => {
    if (boxName === "category") {
      setIsOpen((prev) => ({
        ...prev,
        category: !prev.category,
        startDates: false,
      }));
    } else if (boxName === "appliedOn") {
      setIsOpen((prev) => ({
        ...prev,
        startDates: !prev.startDates,
        category: false,
      }));
    }
  };

  const handleAllClear = () => {
    setSearchTerm("");
    setReward_status([]);
    setCategory_on([]);
    setUpdateChipData([]);
    setselectedStatus([]);
    setInterview_mode([]);
    //   loadListdata();
  };

  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();

      // Create a new KeyboardEvent
      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        keyCode: 13,
        which: 13,
        code: "Enter",
        bubbles: true,
      });
      txtBSearch.current.dispatchEvent(event);
    }
  };
  const sortedReportData = useMemo(() => {
    return [...reportData].sort((a, b) => {
      let valA, valB;

      // Handle subject sorting
      if (sortKey === "subject") {
        valA = a.subject?.map((s) => s.subject).join(", ") || "";
        valB = b.subject?.map((s) => s.subject).join(", ") || "";
      }

      // Default case for other fields
      else {
        valA = a[sortKey] ?? "";
        valB = b[sortKey] ?? "";
      }

      const isNumber = !isNaN(valA) && !isNaN(valB);

      if (isNumber) return sortOrder === "asc" ? valA - valB : valB - valA;

      return sortOrder === "asc"
        ? valA.toString().localeCompare(valB.toString())
        : valB.toString().localeCompare(valA.toString());
    });
  }, [reportData, sortKey, sortOrder]);
  // total table data  with pages
  const totalPages = Math.ceil(feedbackList?.length / rowsPerPage);
  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };

  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    setFeedbackList([]);
    //   loadListdata();
  };

  // Sorting Handler
  const handleSort = (event, sortKey) => {
    event.preventDefault();

    // Toggle the sort order
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);

    // Clone and sort the list
    const sortedList = feedbackList.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      if (a[sortKey] == b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });

    setFeedbackList(sortedList);
  };
  const handleChangeDate_app = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");

    if (name === "FDate" || name === "TDate") {
      setAppDatas((prevState) => {
        const updated = {
          ...prevState,
          [name]: dateFilter,
          Days: "",
        };

        const from = name === "FDate" ? dateFilter : updated.FDate;
        const to = name === "TDate" ? dateFilter : updated.TDate;

        if (from && to) {
          const dateRange = `${from} - ${to}`;

          setAppOns([
            {
              name: dateRange,
              fdate: from,
              edate: to,
              type: "created_dt", //  CONSISTENT
              Days: "",
            },
          ]);
        }

        return updated;
      });
    }
  };

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleView = (event_pk, batch_id, status, event_type, item) => {
    // console.log(id,"id","handleevent");
    navigate(`/ViewInterviewPerfomance`, {
      state: {
        BATCHID: batch_id,
        SEARCHTERM: searchTerm,
        INTERVIEWMODE: interview_mode,
        CATEGORY: intCategory_on,
        DATE: appOns,
        DATEON: appOn,
        PANELID: item.panel_id,
        INTERVIEWID: item.interview_id,
        STATUS: selectedStatus,
        ACTIVETAB: activeTab,
        STUDENTID: userId,
      },
    });
  };
  // Fetch batch list
  useEffect(() => {
    if (!userId) return;

    const fetchBatches = async () => {
      setIsLoading(true);
      try {
        const res = await AxiosInstance.post("api/batch/list/byUser", {
          user_id: userId,
        });

        if (res?.data?.status === true && Array.isArray(res.data.data)) {
          //  filter only batch_type === 5
          const filteredBatches = res.data.data.filter(
            (batch) => Number(batch.batch_type) === 5
          );

          if (isMounted.current) {
            setBatchList(filteredBatches);
          }
        }
      } catch (err) {
        console.error("Failed to load batch list", err);
        if (isMounted.current) {
          setBatchList([]);
        }
        setBatchList([]);
      } finally {
        if (isMounted.current) {
          setIsLoading(false);
        }
        setIsLoading(false);
      }
    };

    fetchBatches();
  }, [userId]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const handleApplyDateFilter = (from, to) => {
    setStartDate(from); //  REQUIRED
    setEndDate(to); //  REQUIRED

    // chip is only for display
    setUpdateChipData((prev) => [
      ...prev.filter((c) => c.type !== "date"),
      {
        name: `${from} - ${to}`,
        type: "date",
      },
    ]);
  };

  const loadListdata = () => {
    if (!userId) return;
    setIsLoading(true);
    const filters = {
      user_id: userId,
      batch_id: "",
      category: category_on.length > 0 ? category_on.map((c) => c.name) : "",
      page_no: "",
      page_size: "",
      start_date: appDatas?.FDate
        ? moment(appDatas.FDate).format("YYYY-MM-DD")
        : "",
      end_date: appDatas?.TDate
        ? moment(appDatas.TDate).format("YYYY-MM-DD")
        : "",
      search: searchTerm || "",
    };

    AxiosInstance.post("api/mockinterview/interview/list_feedback", filters)
      .then((res) => {
        if (res?.data?.status === true && Array.isArray(res.data.data)) {
          const serialNumberAddedData = res.data.data.map((item, index) => ({
            ...item,
            serialNumber: index + 1,
          }));
          setCurrentPage(1);
          setFeedbackList(serialNumberAddedData);
        } else {
          setFeedbackList([]);
        }
      })
      .catch((error) => {
        console.error("Feedback list error:", error);
        setFeedbackList([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const loadListdatas = () => {
    if (!userId) return;
    setIsLoading(true);
    let tempInterviewMode = [];
    let tempStatus = [];
    let tempCategory = [];
    interview_mode.map((obj) => {
      tempInterviewMode.push(obj.name);
    });
    selectedStatus.map((obj) => {
      tempStatus.push(obj.id);
    });
    intCategory_on.map((obj) => {
      tempCategory.push(obj.name);
    });
    const filters = {
      user_id: userId,
      batch_id: batchId,
      search: searchTerm || "",
      interview_mode: interview_mode.length > 0 ? tempInterviewMode : "",
      category: intCategory_on.length > 0 ? tempCategory : "",
      start_date: appData?.FDate
        ? moment(appData.FDate).format("YYYY-MM-DD")
        : "",
      end_date: appData?.TDate
        ? moment(appData.TDate).format("YYYY-MM-DD")
        : "",
      status: selectedStatus.length > 0 ? tempStatus : "",

      page_no: "",
      page_size: "",
    };

    AxiosInstance.post("api/mockinterview/interview/performance_list", filters)
      .then((res) => {
        if (res?.data?.status === true && Array.isArray(res.data.data)) {
          const serialNumberAddedData = res.data.data.map((item, index) => ({
            ...item,
            serialNumber: index + 1,
          }));
          setCurrentPage(1);
          setCombineTest(serialNumberAddedData);
        } else {
          setCombineTest([]);
        }
      })
      .catch((error) => {
        console.error("Feedback list error:", error);
        setFeedbackList([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (!userId) return;

    if (activeTab === 0) {
      loadListdata();
    } else {
      loadListdatas();
    }
  }, [activeTab, searchTerm, userId]);

  const [batchId, setBatchId] = useState();
  const [batchType, setBatchType] = useState();
  const handleTabClick = (index, batch_id, batch_type) => {
    if (isLoading) return;

    if (activeTab !== index) {
      setInterviewMode([]);
      setSelectedSubject([]);
      setselectedStatus([]);
      setAppOns([]);
      setSearchTerm("");
      setAppDatas({
        FDate: "",
        TDate: "",
        Days: "",
        name: "",
      });
      setUpdateChipData([]);
    }

    setActiveTab(index);
    setBatchId(batch_id);
    setBatchType(batch_type);
  };
  const handleChangeDate = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");

    if (name === "FDate" || name === "TDate") {
      setAppData((prevState) => {
        const updated = {
          ...prevState,
          [name]: dateFilter,
          Days: "",
        };

        const from = name === "FDate" ? dateFilter : updated.FDate;
        const to = name === "TDate" ? dateFilter : updated.TDate;

        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOn([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        }

        return updated;
      });
    }
  };
  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        inset: 0,
        backgroundColor: "#fff",
        zIndex: 999,
      }}
    >
      <Loader />
    </div>
  ) : (
    <div className="BathHeader">
      {/* Header */}
      <div className="col-md-6 col-12">
        <h2 className="TitleHeader">Interview Performance</h2>
      </div>

      {/* Tabs */}
      <div className="row mt-3">
        <div className="col-md-12">
          <ul className="nav cm_nav-fill" id="cm_listViewTabs" role="tablist">
            {/* Batch Tabs */}
            {batchList.map((batch, index) => (
              <li className="nav-item" role="presentation" key={batch.batch_id}>
                <a
                  href="#"
                  className={
                    activeTab === index + 1 ? "nav-link active" : "nav-link"
                  }
                  role="tab"
                  aria-selected={activeTab === index + 1}
                  onClick={(e) => {
                    e.preventDefault();
                    handleTabClick(index + 1, batch.batch_id, batch.batch_type);
                  }}
                >
                  {batch.batch_name}
                </a>
              </li>
            ))}

            {/* Static Interview Feedback Tab */}
            <li className="nav-item" role="presentation">
              <a
                href="#"
                className={activeTab === 0 ? "nav-link active" : "nav-link"}
                role="tab"
                aria-selected={activeTab === 0}
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab(0);
                }}
              >
                Interview Feedback
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Content Area */}
      <div className="mt-4">
        {activeTab === 0 ? (
          <div>
            {/* Interview Feedback UI will be added here */}
            <div
              className={`${styles.CourseInfoSec} ${styles.cm_ListViewForm} container-fluid  global_container p-0`}
            >
              <div className={`${styles.cm_container} BathHeader`}>
                <div className="row">
                  <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
                    <div className="input-group">
                      <input
                        ref={txtBSearch}
                        type="text"
                        class={styles.Inputs}
                        // class={styles.Inputs}
                        // className="form-control"
                        id="SearchInput"
                        placeholder="Search by Batch Name"
                        onKeyDown={handleSearch}
                      />
                      <span
                        class={styles.input_group_text}
                        id="SearchInput"
                        onClick={handleSearchFocus}
                      >
                        <span className="material-icons">search</span>
                      </span>
                    </div>
                  </div>

                  <div className="col-md-8 col-12 ListBtn">
                    <ul className="List-Button">
                      <li className="ListBtnItems">
                        {/* <Link to="" className="primaryButton">
                          Add Interview Feedback
                        </Link> */}
                        <Link
                          to="#"
                          className="primaryButton"
                          onClick={(e) => {
                            e.preventDefault();
                            openAddFeedbackModal();
                          }}
                        >
                          Add Interview Feedback
                        </Link>

                        <Modal
                          open={showAddModal}
                          onClose={closeAddFeedbackModal}
                          aria-labelledby="add-feedback-modal-title"
                          aria-describedby="add-feedback-modal-description"
                        >
                          <Box sx={modalStyle}>
                            {/* Header */}
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                p: 2,
                                borderBottom: "1px solid #e0e0e0",
                              }}
                            >
                              <Typography
                                id="add-feedback-modal-title"
                                variant="h6"
                                component="h2"
                                sx={{
                                  fontWeight: 600,
                                  color: "#041134",
                                  fontSize: "18px",
                                }}
                              >
                                Interview Feedback
                              </Typography>

                              <IconButton onClick={closeAddFeedbackModal}>
                                <CloseIcon />
                              </IconButton>
                            </Box>

                            {/* Body */}
                            <Box sx={{ p: 2.5 }}>
                              {/* Batch Dropdown */}
                              <Typography
                                sx={{
                                  color: "#00000080",
                                  fontSize: "14px",
                                  fontWeight: 700,
                                  mb: 1,
                                }}
                              >
                                Batch Name
                              </Typography>

                              <select
                                className="form-control mb-1"
                                value={selectedBatchId}
                                onChange={(e) => {
                                  setSelectedBatchId(e.target.value);
                                  setFormErrors((prev) => ({
                                    ...prev,
                                    batch: "",
                                  }));
                                }}
                              >
                                <option value="">Select Batch</option>
                                {batchList.map((batch) => (
                                  <option
                                    key={batch.batch_id}
                                    value={batch.batch_id}
                                  >
                                    {batch.batch_name}
                                  </option>
                                ))}
                              </select>

                              {formErrors.batch && (
                                <p className="text-danger mb-2">
                                  {formErrors.batch}
                                </p>
                              )}

                              {/* Feedback */}
                              <Typography
                                sx={{
                                  color: "#00000080",
                                  fontSize: "14px",
                                  fontWeight: 700,
                                  mb: 1,
                                }}
                              >
                                Comments
                              </Typography>

                              <textarea
                                className="form-control"
                                rows={4}
                                placeholder="Give us feedback about your interview..."
                                value={feedbackComment}
                                onChange={(e) => {
                                  setFeedbackComment(e.target.value);
                                  setFormErrors((prev) => ({
                                    ...prev,
                                    comment: "",
                                  }));
                                }}
                              />

                              {formErrors.comment && (
                                <p className="text-danger mt-1">
                                  {formErrors.comment}
                                </p>
                              )}
                            </Box>

                            {/* Footer */}
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: 2,
                                p: 1.5,
                                borderTop: "1px solid #e0e0e0",
                              }}
                            >
                              <Typography
                                onClick={closeAddFeedbackModal}
                                sx={{
                                  color: "#c0272d",
                                  fontSize: "14px",
                                  fontWeight: 500,
                                  cursor: "pointer",
                                  px: 2,
                                  py: 1,
                                }}
                              >
                                Cancel
                              </Typography>

                              <Typography
                                onClick={handleSubmitFeedback}
                                sx={{
                                  backgroundColor: "#c0272d",
                                  color: "#fff",
                                  fontSize: "14px",
                                  fontWeight: 500,
                                  cursor: submitLoading
                                    ? "not-allowed"
                                    : "pointer",
                                  px: 3,
                                  py: 1,
                                  borderRadius: "4px",
                                  opacity: submitLoading ? 0.6 : 1,
                                }}
                              >
                                {submitLoading ? "Submitting..." : "Submit"}
                              </Typography>
                            </Box>
                          </Box>
                        </Modal>
                      </li>
                    </ul>
                  </div>
                </div>
                {updateChipData?.filter((kl) => kl.name !== "ActiveTab")
                  .length > 0 ? (
                  <div className="row mt-3">
                    <div className="col-md-12 col-sm-12 col-xs-12 paperil_global ">
                      <Paper
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          flexWrap: "wrap",
                          listStyle: "none",
                          p: 0.5,
                          m: 0,
                        }}
                        component="ul"
                      >
                        {updateChipData
                          ?.filter((kl) => kl.name !== "ActiveTab")
                          ?.map((data, index) => {
                            return (
                              <ListItem key={`${data.type}-${data.name}`}>
                                <Chip
                                  label={data.name}
                                  onDelete={handleDelete(data, index)}
                                />
                              </ListItem>
                            );
                          })}

                        <ListItem className="clearAll_list">
                          <a
                            className="clearAll_listItem"
                            onClick={handleAllClear}
                          >
                            Clear All Filters
                          </a>
                        </ListItem>
                      </Paper>
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}

                {/* Table Section */}
                <div className="row mx-0 mt-2">
                  <div className="col-md-12 table-responsive tableMinHeight px-0">
                    <table className="table" id="tableListHeader">
                      <thead>
                        <tr>
                          {/* S.No */}
                          <th id="th">
                            <span
                              className="textHead_th"
                              onClick={(e) => handleSort(e, "serialNumber")}
                            >
                              S.No
                            </span>
                            <span
                              className="textHead_th material-icons align-middle"
                              onClick={(e) => handleSort(e, "serialNumber")}
                            >
                              import_export
                            </span>
                          </th>
                          {/* Batch Name */}
                          <th id="th">
                            <span
                              className="textHead_th"
                              onClick={(e) => handleSort(e, "name")}
                            >
                              Batch Name
                            </span>
                            <span
                              className="textHead_th material-icons align-middle"
                              onClick={(e) => handleSort(e, "category_name")}
                            >
                              import_export
                            </span>
                          </th>
                          {/* Category */}
                          <th id="th" className={styles.tableThPadding}>
                            <span
                              onClick={(e) => handleSort(e, "category_name")}
                              className="textHead_th"
                            >
                              Category
                            </span>
                            <span
                              onClick={(e) => handleSort(e, "category_name")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                            <span
                              className={`textHead_th align-middle material-icons ${
                                category_on.length > 0
                                  ? styles.active_icons
                                  : ""
                              } ${isOpen.category ? styles.active_icons : ""}`} // Change here
                              onClick={(e) => handleFilter(e, "category")}
                            >
                              filter_list
                            </span>

                            {isOpen.category && (
                              <>
                                <div
                                  className="filterBoxs_testlist mt-3"
                                  ref={filterCategoryRef}
                                >
                                  <div className="col-md-12 form-check filterStatus_list">
                                    <ul className="ulFilterListData">
                                      {categoryId.map((el) => (
                                        <li className="filterListData">
                                          <input
                                            className="ListCheckbox"
                                            type="checkbox"
                                            name={el.name}
                                            value={el.id}
                                            id={el.name}
                                            checked={category_on.some(
                                              (element) => {
                                                if (element.name == el.name) {
                                                  return true;
                                                }
                                                return false;
                                              }
                                            )}
                                            onChange={(e) =>
                                              handleCheckboxChange(
                                                e,
                                                "category"
                                              )
                                            }
                                          />
                                          <label
                                            className="form-check-label filterChipText_withoutBG "
                                            htmlFor={el.name}
                                          >
                                            {el.name}
                                          </label>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                  <div className="borderWidth row">
                                    <ul className="List-Button">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() => handleClear("category")}
                                        className="secondaryButton "
                                      >
                                        Clear
                                      </Link>
                                      <li className="ListBtnItems">
                                        <Link
                                          disabled={
                                            category_on.length === 0
                                              ? true
                                              : false
                                          }
                                          onClick={() =>
                                            handleApplyFilter("category")
                                          }
                                          className="primaryButton"
                                        >
                                          Apply Filter
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </>
                            )}
                          </th>
                          {/* Created Date */}
                          <th
                            id="th"
                            className={styles.tableThPadding}
                            //   ref={filterLastRef}
                          >
                            <span
                              className="textHead_th"
                              onClick={(e) => handleSort(e, "created_dt")}
                            >
                              {" "}
                              Date
                            </span>
                            <span
                              className={`material-icons textHead_th align-middle`}
                              onClick={(e) => handleSort(e, "created_dt")}
                            >
                              import_export
                            </span>

                            <span
                              onClick={(e) => handleFilter(e, "appliedOn")}
                              class={` align-middle material-icons ${
                                (appDatas &&
                                  Object.entries(appDatas).some(
                                    ([key, val]) =>
                                      key !== "name" &&
                                      val !== null &&
                                      val !== undefined &&
                                      val.toString().trim() !== ""
                                  )) ||
                                isOpen.startDates
                                  ? styles.active_icons
                                  : ""
                              }`}
                            >
                              filter_list
                            </span>
                            {isOpen.startDates === true && (
                              <div
                                ref={filterCreatedDateRef}
                                className=" filterBoxs_testlist container mt-2 p-1 BathDet"
                              >
                                <div className="row mt-1">
                                  <div className="col-md-12">
                                    <div class="form-check p-1">
                                      <label
                                        htmlFor="FDate"
                                        className="d-flex form-label"
                                      >
                                        From Date
                                        <span
                                          data-required="true"
                                          aria-hidden="true"
                                        ></span>
                                      </label>
                                      <DatePickerSample
                                        IconInput={"filterIocnBoxInput"}
                                        class={"FilterInputs"}
                                        name={"FDate"}
                                        handleChange={handleChangeDate_app}
                                        fieldInput={appDatas.FDate}
                                        txtAdMDob={fDatePickerRef}
                                        // maxDate={new Date()}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="row mt-1">
                                  <div className="col-md-12">
                                    <div class="form-check p-1">
                                      <label
                                        htmlFor="TDate "
                                        className="d-flex form-label"
                                      >
                                        To Date
                                        <span
                                          data-required="true"
                                          aria-hidden="true"
                                        ></span>
                                      </label>
                                      <DatePickerSample
                                        class={"FilterInputs"}
                                        IconInput={"filterIocnBoxInput"}
                                        name={"TDate"}
                                        handleChange={handleChangeDate_app}
                                        fieldInput={appDatas.TDate}
                                        txtAdMDob={tDatePickerRef}
                                        minDate={appDatas.FDate}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <hr />
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() => handleClear("appliedOns")}
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                    <li className="ListBtnItems">
                                      <Link
                                        disabled={
                                          appDatas.length === 0 ? true : false
                                        }
                                        onClick={() =>
                                          handleApplyFilter("created_dt")
                                        }
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            )}
                          </th>
                          {/* Action */}
                          <th id="th">
                            <span className="textHead_th">Action</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentData.length === 0 ? (
                          <tr>
                            <td colSpan="5" style={{ textAlign: "center" }}>
                              No records to display
                            </td>
                          </tr>
                        ) : (
                          currentData.map((course, index) => (
                            <tr key={course.std_id}>
                              <td id="td">
                                {(currentPage - 1) * rowsPerPage + index + 1}
                              </td>
                              <td id={`${styles.td}tabTh`}>
                                <span
                                  className={styles.ellipsis}
                                  title={course.name}
                                >
                                  {course.name}
                                </span>
                              </td>
                              <td id="td">{course.category}</td>
                              <td id="td">
                                {moment(course.created_dt).format("DD/MM/YYYY")}
                              </td>
                              <td>
                                <button
                                  type="button"
                                  className="view_icon_button"
                                  title="View Feedback"
                                  onClick={() =>
                                    fetchViewFeedback(course.std_id)
                                  }
                                >
                                  <span className="visibleicon material-icons">
                                    visibility
                                  </span>
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                {/* Pagination */}
                <div className="row mt-2">
                  <Pagination
                    rowsPerPage={rowsPerPage}
                    handlePageCount={handlePageCount}
                    startPage={
                      feedbackList && feedbackList?.length > 0
                        ? currentPage * rowsPerPage + 1 - rowsPerPage
                        : 0
                    }
                    endPage={
                      feedbackList && feedbackList?.length > 0
                        ? feedbackList?.length < currentPage * rowsPerPage
                          ? feedbackList?.length
                          : currentPage * rowsPerPage
                        : 0
                    }
                    totalRecords={
                      feedbackList && feedbackList?.length > 0
                        ? feedbackList?.length
                        : 0
                    }
                    handlePrev={(e) => handlePrev(currentPage - 1)}
                    currentPrevPage={currentPage === 1}
                    prevButton={`${styles.prev_buttonViewEvaluator} ${styles.materialIconsRightAndLeft} me-2`}
                    handleNext={() => handleNext(currentPage + 1)}
                    currentNextPage={currentPage === totalPages}
                  />
                </div>
              </div>
              {/* Modal */}
              <Modal
                open={showModal}
                onClose={() => setShowModal(false)}
                aria-labelledby="view-feedback-modal-title"
                aria-describedby="view-feedback-modal-description"
              >
                <Box sx={modalStyle}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      p: 2,
                      borderBottom: "1px solid #e0e0e0",
                    }}
                  >
                    <Typography
                      id="view-feedback-modal-title"
                      variant="h6"
                      component="h2"
                      sx={{
                        fontWeight: 600,
                        color: "#041134",
                        fontSize: "18px",
                      }}
                    >
                      View Feedback
                    </Typography>
                    <IconButton
                      onClick={() => setShowModal(false)}
                      sx={{ color: "#666", "&:hover": { color: "#333" } }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Box>

                  <Box sx={{ p: 2.5, minHeight: "100px" }}>
                    <Typography
                      sx={{
                        color: "#00000080",
                        fontSize: "14px",
                        fontWeight: 700,
                        mb: 1,
                      }}
                    >
                      Comments
                    </Typography>
                    <Typography
                      id="view-feedback-modal-description"
                      sx={{
                        lineHeight: 1.6,
                        fontSize: "16px",
                        fontWeight: 700,
                        wordBreak: "break-word",
                        overflowWrap: "anywhere",
                        whiteSpace: "pre-wrap",
                        maxHeight: "200px",
                        overflowY: "auto",
                      }}
                    >
                      {selectedFeedback?.comment || "No feedback available"}
                    </Typography>
                  </Box>

                  {/* <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      p: 1.5,
                      borderTop: "1px solid #e0e0e0",
                    }}
                  > */}
                  {/* <Typography
                      onClick={() => setShowModal(false)}
                      sx={{
                        color: "#c0272d",
                        fontSize: "14px",
                        fontWeight: 500,
                        cursor: "pointer",
                        px: 2,
                        py: 1,
                        "&:hover": { opacity: 0.8 },
                      }}
                    >
                      Close
                    </Typography> */}
                  {/* </Box> */}
                </Box>
              </Modal>

              {isLoading && (
                <div
                  className="loaderApi"
                  style={{
                    display: isLoading ? "flex" : "none",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "white",
                    zIndex: 999,
                  }}
                >
                  {isLoading && <Loader />}
                </div>
              )}
            </div>
          </div>
        ) : (
          <div>
            {/* Placeholder for batch-based content */}
            <div>
              <InterviewPerformance
                studentId={userId}
                reportData={combineTest}
                interviewMode={interviewMode}
                interview_mode={interview_mode}
                isOpen={isOpen}
                intCategory={categoryId}
                selectedCategory={intCategory_on}
                setIsopen={setIsOpen}
                appData={appData}
                appOn={appOn}
                selectedStatus={selectedStatus}
                setselectedStatus={setselectedStatus}
                handleApplyFilter={handleApplyFilter}
                handleClearOn={handleClearOn}
                handleDelete={handleDelete}
                handleChangeDate={handleChangeDate}
                handleCheckboxChange={handleCheckboxChange}
                updateChipData={updateChipData}
                handleSearchFocus={handleSearchFocus}
                handleAllClear={handleAllClear}
                handleSort={handleSort}
                handleView={handleView}
                handleFilter={handleFilter}
                // selectedEvent={selectedEvent}
                // subject={selectedSubject}
                // selectetSubject={selectedSubject}
                // testTopics={testTopics}
                // selectedTestTopics={selectedTestTopics}
                // setSelectedEvent={setSelectedEvent}
                // handleCheckboxChange={handleCheckboxChange}
                // handleApplyFilter={handleApplyFilter}
                // selectedSubject={selectedSubject}
                // setSelectedSubject={setSelectedSubject}
                // status={status}
                // setselectedStatus={setselectedStatus}
                // settestTopics={settestTopics}
                // dateFilter={dateFilter}
                // handleDateFilterChange={handleDateFilterChange}
                // isOpen={isOpen}
                // handleChange={handleMarksChange}
                // initialfields={initialfields}
                // setIsopen={setIsopen}
                // handleDelete={handleDelete}
                // appData={appData}
                // setAppData={setAppData}
                // updateChipData={updateChipData}
                // handleFilterSearch={handleFilterSearch}
                // appOn={appOn}
                // setAppOn={setAppOn}
                // batchId={batchId}
                // batchType={batchType}
                // activeTab={activeTab}
                // handleAppliedOn={handleAppliedOn}
                // handleClear={handleClear}
                //
                // selectedStatus={selectedStatus}
                // IsLoading={isLoading}
                // setIsLoading={setIsLoading}
                // handleView={handleView}
                // // debouncedSearch={debouncedSearch}
                // searchTerm={searchTerm}
                // setSearchTerm={setSearchTerm}
                // handleSearch={handleSearch}
                // txtBSearch={txtBSearch}
                // handleSearchFocus={handleSearchFocus}
                // handleAllClear={handleAllClear}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default FeedbackList;
